import React from "react";
import DownloadProgressBar from "../common/DownloadProgressBar";
import cdrFilesService from '../../../services/cdrFilesService';

export default function OrdersListPositions({
  orderPositions,
  itemsCdrFiles,
  selectedIds,
  setSelectedIds,
  downloadProgress,
}) {
  const toggleOne = (id) => {
    setSelectedIds(
      selectedIds.includes(id)
        ? selectedIds.filter((x) => x !== id)
        : [...selectedIds, id]
    );
  };

  const toggleAll = () => {
    if (selectedIds.length === orderPositions.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(orderPositions.map((x) => x.id));
    }
  };

  return (
    <div className="card">
      <div className="card-body" style={{ maxHeight: "75vh", overflowY: "auto" }}>

        {/* Выбрать все */}
        {orderPositions.length > 0 && (
          <div className="d-flex align-items-center mb-2">
            <input
              type="checkbox"
              className="form-check-input me-2"
              checked={selectedIds.length === orderPositions.length}
              ref={(el) =>
                el && (el.indeterminate =
                  selectedIds.length > 0 &&
                  selectedIds.length < orderPositions.length)
              }
              onChange={toggleAll}
            />
            <span>
              Выбрано {selectedIds.length} из {orderPositions.length}
            </span>
          </div>
        )}

        {orderPositions.map((p) => {
          const isSelected = selectedIds.includes(p.id);

          return (
            <div key={p.id} className="border rounded p-2 mb-2">
              <div className="d-flex">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={isSelected}
                  onChange={() => toggleOne(p.id)}
                />

                {itemsCdrFiles[p.itemId]?.imageId ? (
                        <img className="me-2"
                          src={cdrFilesService.getCdrfilePreview(itemsCdrFiles[p.itemId]?.imageId)}
                          alt={p.article}
                          style={{ width: "150px", height: "150px", objectFit: "contain" }}
                        />
                      ) : (
                        <div style={{ width: "150px", height: "150px", backgroundColor: "#eee" }} />
                )}
                

                <div style={{ flexGrow: 1 }}>
                  <div className="fw-bold">{p.name}</div>
                  <div className="text-muted">{p.article}</div>
                  <small className="text-secondary">
                    {new Date(p.creationTime).toLocaleString()}
                  </small>
                </div>
              </div>
            </div>
          );
        })}

      </div>
    </div>
  );
}
